import { getRange } from './queryUtils';
const rangeName = {
    pax: 'PAX',
    besta: 'BESTÅ',
    platsa: 'PLATSA',
    eket: 'EKET',
    smastad: 'SMÅSTAD',
    ivar: 'IVAR',
    billy: 'BILLY',
    bror: 'BROR',
    kallax: 'KALLAX',
    boaxel: 'BOAXEL',
    ladmakare: 'LÅDMAKARE',
    jonaxel: 'JONAXEL',
    knoxhult: 'KNOXHULT',
    aurdal: 'AURDAL',
    elvarli: 'ELVARLI',
    trofast: 'TROFAST'
};
export function getRangeName(range) {
    range = range || getRange();
    return rangeName[range.toLowerCase()] || range.toUpperCase();
}
//# sourceMappingURL=rangeName.js.map